import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'dashboard' },
      meta: {
        auth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: true
      }
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import(/* webpackChunkName: "customers" */ '@/views/Customers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customers', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'customersDetail',
        component: () => import(/* webpackChunkName: "customers" */ '@/views/Customers.vue')
      }]
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "contacts" */ '@/views/Contacts.vue'),
      meta: {
        title: Vue.i18n.translate('strings.contacts', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'contactsDetail',
        component: () => import(/* webpackChunkName: "contacts" */ '@/views/Contacts.vue')
      }]
    },
    {
      path: '/suppliers',
      name: 'suppliers',
      component: () => import(/* webpackChunkName: "suppliers" */ '@/views/Suppliers.vue'),
      meta: {
        title: Vue.i18n.translate('strings.suppliers', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'suppliersDetail',
        component: () => import(/* webpackChunkName: "suppliers" */ '@/views/Suppliers.vue')
      }]
    },
    {
      path: '/products',
      name: 'products',
      component: () => import(/* webpackChunkName: "products" */ '@/views/Products.vue'),
      meta: {
        title: Vue.i18n.translate('strings.products', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'productsDetail',
        component: () => import(/* webpackChunkName: "products" */ '@/views/Products.vue')
      }]
    },
    {
      path: '/supplies',
      name: 'supplies',
      component: () => import(/* webpackChunkName: "supplies" */ '@/views/Supplies.vue'),
      meta: {
        title: Vue.i18n.translate('strings.supplies', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'suppliesDetail',
        component: () => import(/* webpackChunkName: "supplies" */ '@/views/Supplies.vue')
      }]
    },
    {
      path: '/quotations',
      name: 'quotations',
      component: () => import(/* webpackChunkName: "quotations" */ '@/views/Quotations.vue'),
      meta: {
        title: Vue.i18n.translate('strings.quotations', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'quotationsDetail',
        component: () => import(/* webpackChunkName: "quotations" */ '@/views/Quotations.vue')
      }]
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import(/* webpackChunkName: "projects" */ '@/views/Projects.vue'),
      meta: {
        title: Vue.i18n.translate('strings.projects', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'projectsDetail',
        component: () => import(/* webpackChunkName: "projects" */ '@/views/Projects.vue')
      }]
    },
    {
      path: '/project/:id/detail',
      name: 'project_details',
      component: () => import(/* webpackChunkName: "project_details" */ '@/views/ProjectDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.projects', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/create-quotation',
      name: 'create-quotation',
      component: () => import(/* webpackChunkName: "users" */ '@/views/CreateQuotes.vue'),
      meta: {
        title: Vue.i18n.translate('strings.quotations', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'createQuoteDetail',
        component: () => import(/* webpackChunkName: "users" */ '@/views/CreateQuotes.vue')
      }]
    },
    {
      path: '/branches',
      name: 'branches',
      component: () => import(/* webpackChunkName: "branches" */ '@/views/Branches.vue'),
      meta: {
        title: Vue.i18n.translate('strings.branches', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'branchesDetail',
        component: () => import(/* webpackChunkName: "branches" */ '@/views/Branches.vue')
      }]
    },
    {
      path: '/requisitioners',
      name: 'requisitioners',
      component: () => import(/* webpackChunkName: "requisitioners" */ '@/views/Requisitioners.vue'),
      meta: {
        title: Vue.i18n.translate('strings.requisitioners', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'requisitionersDetail',
        component: () => import(/* webpackChunkName: "requisitioners" */ '@/views/Requisitioners.vue')
      }]
    },
    {
      path: '/customers/:customerId/addresses/',
      name: 'customer_addresses',
      component: () => import(/* webpackChunkName: "customer_addresses" */ '@/views/CustomerAddresses.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customer_addresses', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'customerAddressesDetail',
        component: () => import(/* webpackChunkName: "customer_addresses" */ '@/views/CustomerAddresses.vue')
      }]
    },
    {
      path: '/requisitions',
      name: 'requisitions',
      component: () => import(/* webpackChunkName: "requisitions" */ '@/views/Requisitions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.requisitions', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'requisitionsDetail',
        component: () => import(/* webpackChunkName: "requisitions" */ '@/views/Requisitions.vue')
      }]
    },
    {
      path: '/purchase_orders',
      name: 'purchase_orders',
      component: () => import(/* webpackChunkName: "purchase_orders" */ '@/views/PurchaseOrders.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'purchaseOrdersDetail',
        component: () => import(/* webpackChunkName: "purchase_orders" */ '@/views/PurchaseOrders.vue')
      }]
    },
    {
      path: '/requisition/:id/detail',
      name: 'requisition_details',
      component: () => import(/* webpackChunkName: "requisition_details" */ '@/views/RequisitionDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.requisition_details', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/receptions',
      name: 'receptions',
      component: () => import(/* webpackChunkName: "receptions" */ '@/views/Receptions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.receptions', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'receptionsDetail',
        component: () => import(/* webpackChunkName: "receptions" */ '@/views/Receptions.vue')
      }]
    },
    {
      path: '/reception_details',
      name: 'reception_details',
      component: () => import(/* webpackChunkName: "reception_details" */ '@/views/ReceptionDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.reception_details', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'receptionDetailsDetail',
        component: () => import(/* webpackChunkName: "reception_details" */ '@/views/ReceptionDetails.vue')
      }]
    },
    {
      path: '/supplier_invoices',
      name: 'supplier_invoices',
      component: () => import(/* webpackChunkName: "supplier_invoices" */ '@/views/SupplierInvoices.vue'),
      meta: {
        title: Vue.i18n.translate('strings.supplier_invoices', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'supplierInvoicesDetail',
        component: () => import(/* webpackChunkName: "supplier_invoices" */ '@/views/SupplierInvoices.vue')
      }]
    },
    {
      path: '/customer_purchase_orders',
      name: 'customer_purchase_orders',
      component: () => import(/* webpackChunkName: "customer_purchase_orders" */ '@/views/CustomerPurchaseOrders.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customer_purchase_orders', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'customerPurchaseOrdersDetail',
        component: () => import(/* webpackChunkName: "customer_purchase_orders" */ '@/views/CustomerPurchaseOrders.vue')
      }]
    },
    {
      path: '/supplier_payments',
      name: 'supplier_payments',
      component: () => import(/* webpackChunkName: "supplier_payments" */ '@/views/SupplierPayments.vue'),
      meta: {
        title: Vue.i18n.translate('strings.supplier_payments', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'supplierPaymentsDetail',
        component: () => import(/* webpackChunkName: "supplier_payments" */ '@/views/SupplierPayments.vue')
      }]
    },
    {
      path: '/production_statuses',
      name: 'production_statuses',
      component: () => import(/* webpackChunkName: "production_statuses" */ '@/views/ProductionStatuses.vue'),
      meta: {
        title: Vue.i18n.translate('strings.production_statuses', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'productionStatusesDetail',
        component: () => import(/* webpackChunkName: "production_statuses" */ '@/views/ProductionStatuses.vue')
      }]
    },
    {
      path: '/production_areas',
      name: 'production_areas',
      component: () => import(/* webpackChunkName: "production_areas" */ '@/views/ProductionAreas.vue'),
      meta: {
        title: Vue.i18n.translate('strings.production_areas', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'productionAreasDetail',
        component: () => import(/* webpackChunkName: "production_areas" */ '@/views/ProductionAreas.vue')
      }]
    },
    {
      path: '/customer_purchase_order/:id/detail',
      name: 'customer_purchase_order_details',
      component: () => import(/* webpackChunkName: "requisition_details" */ '@/views/CustomerPurchaseOrderDetails.vue'),
      meta: {
        title: Vue.i18n.translate('strings.customer_purchase_order_details', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/invoices',
      name: 'invoices',
      component: () => import(/* webpackChunkName: "invoices" */ '@/views/Invoices.vue'),
      meta: {
        title: Vue.i18n.translate('strings.invoices', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'invoicesDetail',
        component: () => import(/* webpackChunkName: "invoices" */ '@/views/Invoices.vue')
      }]
    },
    {
      path: '/invoice/:id/detail',
      name: 'invoice_detail',
      component: () => import(/* webpackChunkName: "invoices" */ '@/components/invoices/InvoiceDetail.vue'),
      meta: {
        title: Vue.i18n.translate('strings.invoices', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/create-invoice',
      name: 'create-invoice',
      component: () => import(/* webpackChunkName: "invoices" */ '@/components/invoices/CreateInvoice.vue'),
      meta: {
        title: Vue.i18n.translate('strings.invoices', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/payments',
      name: 'payments',
      component: () => import(/* webpackChunkName: "payments" */ '@/views/Payments.vue'),
      meta: {
        title: Vue.i18n.translate('strings.payments', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'paymentsDetail',
        component: () => import(/* webpackChunkName: "payments" */ '@/views/Payments.vue')
      }]
    },
    {
      path: '/tax_receipts',
      name: 'tax_receipts',
      component: () => import(/* webpackChunkName: "tax_receipts" */ '@/views/TaxReceipts.vue'),
      meta: {
        title: Vue.i18n.translate('strings.tax_receipts', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'taxReceiptsDetail',
        component: () => import(/* webpackChunkName: "tax_receipts" */ '@/views/TaxReceipts.vue')
      }]
    },
    // New Route
    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
      meta: {
        title: Vue.i18n.translate('strings.users', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue')
      }]
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/AuthLogin.vue'),
      meta: {
        title: Vue.i18n.translate('login.login', null),
        auth: false
      }
    },
    {
      path: '/register',
      name: 'register',
      // route level code-splitting
      // this generates a separate chunk (register.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "register" */ '@/views/Auth/AuthRegister.vue'),
      meta: {
        title: Vue.i18n.translate('login.register', null),
        auth: false
      }
    },
    {
      path: '/password/reset',
      name: 'reset',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetLink.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/password/reset/:token',
      name: 'reset.token',
      component: () => import(/* webpackChunkName: "Reset" */ '@/views/Auth/AuthResetForm.vue'),
      meta: {
        title: Vue.i18n.translate('login.reset_password', null),
        auth: false
      }
    },
    {
      path: '/email/verify',
      name: 'verification.notice',
      props: true,
      component: () => import(/* webpackChunkName: "verification" */ '@/views/Auth/AuthVerify.vue'),
      meta: {
        title: Vue.i18n.translate('verification.title', null),
        auth: false
      }
    },
    {
      path: '/requisitions-mailboxes',
      name: 'requisitions-mailboxes',
      component: () => import(/* webpackChunkName: "requisitions-mailboxes" */ '@/views/RequisitionsMailboxes.vue'),
      meta: {
        title: Vue.i18n.translate('strings.requisitions-mailboxes', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/create-purcharse-orders',
      name: 'create-purcharse-orders',
      component: () => import(/* webpackChunkName: "create-purcharse-orders" */ '@/views/CreatePurcharseOrders.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purcharse_orders', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      },
      children: [{
        path: ':id',
        name: 'createPurcharseOrdersDetails',
        component: () => import(/* webpackChunkName: "create-purcharse-orders" */ '@/views/CreatePurcharseOrders.vue')
      }]
    },
    {
      path: '/purcharse-orders/:id/summary',
      name: '/purcharse-orders/:id/summary',
      component: () => import(/* webpackChunkName: "users" */ '@/components/purchase-order/OrderSummary.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/warehouse-receptions',
      name: '/warehouse-receptions',
      component: () => import(/* webpackChunkName: "users" */ '@/views/WarehouseReceptions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/warehouse-receptions/:folio/purchase',
      name: '/warehouse-receptions/:folio/purchase',
      component: () => import(/* webpackChunkName: "users" */ '@/views/WarehouseReceptions.vue'),
      meta: {
        title: Vue.i18n.translate('strings.purchase_orders', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    },
    {
      path: '/manufacturing',
      name: '/manufacturing',
      component: () => import(/* webpackChunkName: "users" */ '@/views/Manufacturings.vue'),
      meta: {
        title: Vue.i18n.translate('strings.manufacturing', null),
        auth: {
          roles: 'Admin',
          forbiddenRedirect: '/'
        }
      }
    }
  ]
})

// It's required for VueAuth
Vue.router = router

export default router
